export var InspectionNodeState;
(function (InspectionNodeState) {
    InspectionNodeState["NEW"] = "NEW";
    InspectionNodeState["VERY_GOOD"] = "VERY_GOOD";
    InspectionNodeState["GOOD"] = "GOOD";
    InspectionNodeState["DECENT"] = "DECENT";
    InspectionNodeState["BAD"] = "BAD";
    InspectionNodeState["VERY_BAD"] = "VERY_BAD";
})(InspectionNodeState || (InspectionNodeState = {}));
